import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, Search } from "lucide-react";
import { CATEGORIES } from "../lib/api";
import JardinIntime from "./JardinIntime";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <header
        data-testid="navbar"
        className="sticky top-0 z-40 bg-[#FFFDF7] border-b-2 border-black"
      >
        <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-3 flex items-center justify-between gap-4">
          <Link
            to="/"
            data-testid="logo-home-link"
            className="flex items-center gap-2 group"
            onClick={() => setOpen(false)}
          >
            <img
              src="/logo-bonsang.png"
              alt="Bon Sang"
              className="h-10 lg:h-12 w-auto transition-transform group-hover:rotate-[-6deg]"
            />
            <span className="font-display-black text-3xl lg:text-4xl tracking-tighter">
              BON SANG<span className="text-[#FA6157]">!</span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {CATEGORIES.map((c) => (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                data-testid={`nav-cat-${c.slug}`}
                className="px-3 py-2 text-sm font-bold uppercase tracking-wide hover:bg-black hover:text-[#FFD01E] rounded-full transition-colors"
              >
                {c.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              data-testid="open-jardin-intime"
              onClick={() => setSearchOpen(true)}
              className="brutal-btn brutal-btn-yellow !py-2 !px-4 !text-xs"
            >
              <Search size={16} strokeWidth={2.5} />
              <span className="hidden sm:inline">Jardin Intime</span>
            </button>
            <button
              data-testid="mobile-menu-toggle"
              onClick={() => setOpen(!open)}
              className="lg:hidden p-2 border-2 border-black rounded-full"
              aria-label="menu"
            >
              {open ? <X size={18} /> : <Menu size={18} />}
            </button>
          </div>
        </div>

        {open && (
          <div
            data-testid="mobile-menu-panel"
            className="lg:hidden border-t-2 border-black bg-[#D9C5FD] px-5 py-5 flex flex-col gap-2"
          >
            {CATEGORIES.map((c) => (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                onClick={() => setOpen(false)}
                data-testid={`mnav-cat-${c.slug}`}
                className="font-display text-3xl"
              >
                {c.label} →
              </Link>
            ))}
          </div>
        )}
      </header>

      <JardinIntime
        open={searchOpen}
        onClose={() => setSearchOpen(false)}
        onPickResult={(slug) => {
          setSearchOpen(false);
          navigate(`/article/${slug}`);
        }}
      />
    </>
  );
}
